import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bell, Receipt, UserCircle, Gear, SignOut } from "@phosphor-icons/react";

export default function MorePage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const menuItems = [
    { icon: Receipt, label: "Understanding Your Pay", path: "/understanding-pay", roles: ["employee", "manager", "administrator"] },
    { icon: Bell, label: "Announcements", path: "/announcements", roles: ["employee", "manager", "administrator"] },
    { icon: Receipt, label: "Pay History", path: "/pay-history", roles: ["employee", "manager", "administrator"] },
    { icon: Receipt, label: "Health Reimbursement", path: "/health-reimbursement", roles: ["employee", "manager", "administrator"] },
    { icon: UserCircle, label: "My Profile", path: "/profile", roles: ["employee", "manager", "administrator"] },
    { icon: Gear, label: "Settings", path: "/settings", roles: ["employee", "manager", "administrator"] },
    { icon: Receipt, label: "Paste Import (hours & sales)", path: "/admin/import/text", roles: ["manager", "administrator"] },
  ];

  const filteredItems = menuItems.filter(item => item.roles.includes(user?.role));

  return (
    <div className="min-h-screen bg-background pb-20">
      <div className="border-b border-border bg-card px-4 py-4">
        <h1 className="text-2xl sm:text-3xl font-semibold text-foreground">More</h1>
        <p className="text-sm text-muted-foreground mt-1">Settings and additional features</p>
      </div>

      <div className="p-4 space-y-4">
        <Card>
          <CardContent className="p-0">
            {filteredItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.path || item.label}
                  onClick={() => navigate(item.path)}
                  className="w-full flex items-center gap-3 p-4 hover:bg-muted transition-colors border-b last:border-b-0"
                >
                  <Icon size={24} className="text-muted-foreground" />
                  <span className="text-foreground font-medium">{item.label}</span>
                </button>
              );
            })}
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4">
            <Button 
              onClick={handleLogout}
              data-testid="logout-button"
              variant="destructive"
              className="w-full flex items-center gap-2"
            >
              <SignOut size={20} />
              Logout
            </Button>
          </CardContent>
        </Card>

        <div className="text-center text-xs text-muted-foreground">
          <p>GT L.A.B Careers</p>
          <p className="mt-1">{user?.display_name || user?.name} • {user?.employment_role || user?.role}</p>
        </div>
      </div>
    </div>
  );
}
